/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Login_Offline_Activating_ButtonInputs */

const en_login_offline_activating_button = /** @type {(inputs: Login_Offline_Activating_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Activating...`)
};

const fr_login_offline_activating_button = /** @type {(inputs: Login_Offline_Activating_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Activation en cours...`)
};

const de_login_offline_activating_button = /** @type {(inputs: Login_Offline_Activating_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktivierung...`)
};

const it_login_offline_activating_button = /** @type {(inputs: Login_Offline_Activating_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Attivazione in corso...`)
};

const ru_login_offline_activating_button = /** @type {(inputs: Login_Offline_Activating_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Активация...`)
};

const es_login_offline_activating_button = /** @type {(inputs: Login_Offline_Activating_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Activando...`)
};

const zh_cn2_login_offline_activating_button = /** @type {(inputs: Login_Offline_Activating_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`激活...`)
};

const ja_login_offline_activating_button = /** @type {(inputs: Login_Offline_Activating_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`有効化中...`)
};

const hi_login_offline_activating_button = /** @type {(inputs: Login_Offline_Activating_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सक्रिय हो रहा है...`)
};

const pt_pt2_login_offline_activating_button = /** @type {(inputs: Login_Offline_Activating_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ativando...`)
};

/**
* | output |
* | --- |
* | "Activating..." |
*
* @param {Login_Offline_Activating_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const login_offline_activating_button = /** @type {((inputs?: Login_Offline_Activating_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_Offline_Activating_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_login_offline_activating_button(inputs)
	if (locale === "de") return de_login_offline_activating_button(inputs)
	if (locale === "it") return it_login_offline_activating_button(inputs)
	if (locale === "ru") return ru_login_offline_activating_button(inputs)
	if (locale === "es") return es_login_offline_activating_button(inputs)
	if (locale === "zh-CN") return zh_cn2_login_offline_activating_button(inputs)
	if (locale === "ja") return ja_login_offline_activating_button(inputs)
	if (locale === "hi") return hi_login_offline_activating_button(inputs)
	if (locale === "pt-PT") return pt_pt2_login_offline_activating_button(inputs)
	return en_login_offline_activating_button(inputs)
});